<template>
  <Multiselect
               :class="{'multiselect-sm': small}"
               v-model="vModel"
               :options="options"
               :custom-label="(opt) => `${opt.merchantName} - ${opt.name} (${opt.currency})`"
               track-by="id"
               select-label="Select"
               :placeholder="helper.trans('labels.stores')"
               open-direction="bottom"
               :multiple="multiple"
               :searchable="true"
               :loading="isLoading"
               :internal-search="false"
               :clear-on-select="!multiple"
               :close-on-select="!multiple"
               :options-limit="100"
               :limit="1000"
               :show-no-results="false"
               :hide-selected="multiple"
               @search-change="asyncFindStores"
  >
  </Multiselect>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, Prop, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import {numberFormatter} from "@/service/NumberFormatter";
import Multiselect from "vue-multiselect";
import TraderDTO from "@/models/TraderDTO";
import APIClient from "@/service/APIClient";
import PaginationDTO from "@/models/PaginationDTO";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";

const api = new APIClient()

export default defineComponent({
  emits: ['update:modelValue'],
  components: {
    Multiselect
  },
  props: {
    small: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    multiple: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    modelValue: {
      type: Array as PropType<any>,
      default: null
    } as Prop<any>,
  },
  setup(props, {emit}) {

    const state = reactive({
      isLoading: false as boolean,
      options: [] as MerchantStoreDTO[]
    })

    const asyncFindStores = async (query: string) => {
      state.isLoading = true;
      state.options = (await api.merchantStores({limit: 100, offset: 0} as PaginationDTO, {query: query})).items;
      state.isLoading = false
    }

    const vModel = computed({
      get(): any {
        return props.modelValue
      },
      set(value: any): void {
        emit('update:modelValue', value);
      },
    });

    onMounted(() => {
      asyncFindStores('')
    });

    return {
      ...toRefs(state),
      vModel,
      asyncFindStores,
      helper,
      numberFormatter
    }
  }
})
</script>
